<template>
  <div class="requirements">
    <IconExclamation />
    <div class="requirements-box">

      <div 
        v-for="(requirement, index) in requirements" 
        :key="index" 
        class="box-element"
      >
        <div :class="['element-check', { 
          'check-active': requirement.active 
        }]"></div>
        <div v-html="requirement.title"></div>
      </div>

    </div>
  </div>
</template>

<script>
  import IconExclamation from '@/components/icons/IconExclamation';

  export default {
    components: {
      IconExclamation
    },
    props: {
      requirements: Array
    }
  }
</script>

<style scoped>
  .requirements {
    position: relative;
    margin-left: 8px;
    cursor: pointer;
  }

  .requirements svg {
    width: 12px;
    fill: #5f6779;
  }

  .requirements .requirements-box {
    width: 215px;
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 6px;
    left: 50%;
    top: 25px;
    padding: 10px;
    transform: translate(-50%, 0);
    border-radius: 5px;
    background: rgba(33, 39, 50, 0.95);
    box-shadow: 0 0 5px rgba(25, 30, 39, 0.9);
    visibility: hidden;
    z-index: 10;
  }

  .requirements .requirements-box::before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    left: 50%;
    top: -8px;
    transform: translate(-50%, 0);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgba(33, 39, 50, 0.95);
  }

  .requirements:hover .requirements-box {
    visibility: visible;
  }

  .requirements .box-element {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    color: #767c8b;
  }

  .requirements .box-element:deep(span) {
    background: linear-gradient(180deg, #fd3b31 0%, #fd6b31 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .requirements .element-check {
    width: 14px;
    height: 14px;
    position: relative;
    border-radius: 2px;
    background: #191e27;
  }

  .requirements .element-check.check-active::after {
    content: '';
    width: 6px;
    height: 6px;
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    background: linear-gradient(180deg, #fd3b31 0%, #fd6b31 100%);
  }
</style>